import { MentorForm } from '../../components';
import { useNavigate } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import { ProfileContext } from '../../contexts';
import { registerView } from '../../helpers';

export const MentorReview = () => {
  const { profile } = useContext(ProfileContext);
  const navigate = useNavigate();
  useEffect(() => {
    if (typeof profile?.deadline?.isDeadlineOver !== 'boolean') return;
    if (profile?.nar_membership_type !== 'S') {
      registerView(profile, 'Unauthorized');
      navigate('/');
      return;
    }
    registerView(profile);
  }, [profile?.deadline?.isDeadlineOver]);

  return (
    <div className="App-content">
      <div className="App-row">
        <MentorForm isReview userData={profile} />
      </div>
      <div className="App-row">
        <p>
          <br />
        </p>
      </div>
    </div>
  );
};
